import { get } from "lodash"

import type { Caching } from "@/lib/caching"
import { isCachedPayload } from "@/lib/caching/isPayload"
import type { Validation } from "@/lib/validation"

export const getCachedPayload = <Store extends Caching.BaseStore, Data>({
  keys,
  name = keys.join(`.`),
  store,
  validator,
}: {
  keys: Caching.Keys<Store>
  name?: string
  store: Store
  validator: Validation.Validator<Data>
}) => {
  const payload = get(store, keys)

  if (!payload) {
    return
  }

  if (!isCachedPayload(payload)) {
    console.warn(
      `getCachedPayload found and ignored an entry in the store that wasn't a correctly cached payload:`,
      { keys, store, payload }
    )
    return
  }

  if (!validator.isValid(payload.data, name)) {
    console.warn(
      `getCachedPayload found and ignored a payload in the store with invalid data:`,
      { keys, store, payload },
      { failures: validator.getFailures(payload.data, name) }
    )
    return
  }

  return payload as Caching.Payload<Data>
}
